import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import { PrivateOutlet } from '@/app/shared/utils/PrivateOutlet';
import { PageRoutes } from './routes';
import { DebtorPortalDashboard } from '@/app/features/DebtorPortal/Dashboard';
import { InvoiceDetail } from '@/app/features/DebtorPortal/InvoiceDetail';
import { NOACenter } from '@/app/features/DebtorPortal/NOACenter';
import { CommunicationPreferences } from '@/app/features/DebtorPortal/CommunicationPreferences';
import { useFeatureFlags } from '@/app/shared/utils/hooks/useFeatureFlags';

const AuthenticatedRoutes: React.FC = () => {
    const { EnableNoaCenter, EnableCommunicationPreferences } = useFeatureFlags();

    // render pages from routes
    return (
        <Routes>
          <Route element={<PrivateOutlet />}>
            <Route index element={<Navigate to={PageRoutes.DASHBOARD} />} />
            <Route
                path={PageRoutes.DASHBOARD}
                element={<DebtorPortalDashboard />}
            />
            <Route
                path={PageRoutes.INVOICES}
                element={<InvoiceDetail />}
            />
            {EnableNoaCenter && (
                <Route
                    path={PageRoutes.NOA_CENTER}
                    element={<NOACenter />}
                />
            )}
            {EnableCommunicationPreferences && (
                <Route
                    path={PageRoutes.COMMUNICATION_PREFERENCES}
                    element={<CommunicationPreferences />}
                />
            )}
          </Route>
          <Route
              path="*"
              element={<div>Path not found</div>}
          />
        </Routes>
    );
};

export default AuthenticatedRoutes;
